var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAckodriveHome = function SvgAckodriveHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M11.482 3.172a.864.864 0 0 1 1.036 0l7.467 5.59c.218.163.346.419.346.691v10.683a.864.864 0 0 1-.864.864H4.532a.864.864 0 0 1-.864-.864V9.453c0-.272.128-.528.346-.692zM5.397 9.886v9.385h13.206V9.886L12 4.944z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    fillRule: "evenodd",
    d: "M11.137 20.136v-6.511h1.728v6.51z",
    clipRule: "evenodd"
  })));
};
export default SvgAckodriveHome;